import type { Subscription } from '../../../types';

import useAxiosClient from '@blueshift-ui/fetch/dist/hooks/use-axios-client';
import useMutation from '@blueshift-ui/fetch/dist/hooks/use-mutation';

interface UpdateSubscriptionProps {
  currentSubscription?: Subscription | null;
}

interface UpdateSubscriptionRequest {
  parameters: {
    new_item_id?: string;
    new_purchase_price_cents?: number;
    old_item_id: string;
    old_purchase_price_cents: number;
  };
  scheduled_at: string;
  transformation_type: string;
}

function useUpdateSubscription({ currentSubscription }: UpdateSubscriptionProps) {
  const axios = useAxiosClient();

  const { makeMutation: makeRequestUpdateSubscription, isLoading } = useMutation<
    UpdateSubscriptionRequest,
    void
  >({
    mutationKey: 'update-subscription',
    mutationOptions: {
      meta: {
        client: axios,
      },
    },
    request: {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      url: `/v1/subscriptions/${currentSubscription?.id}/transformations`,
    },
  });

  return { isLoading, makeRequestUpdateSubscription };
}

export default useUpdateSubscription;
